export default function () {
  return {
    products: [],
    subtotal: 0,
    total: 0,
    quantity: 0,
    delivery: 0
  };
}